<ui-form-section title="Totales" [flush]="true">
  <div class="ui-document-totals__bar">
    <div class="ui-document-totals__start">
      @if (currencyMode() === 'label') {
        <div class="ui-document-totals__labels">
          <div class="ui-document-totals__metric">
            <span class="ui-document-totals__label">Divisa</span>
            <span class="ui-document-totals__value">{{ currency() }}</span>
          </div>
          @if (exchangeRate() !== null) {
            <div class="ui-document-totals__metric">
              <span class="ui-document-totals__label">Tipo de cambio</span>
              <span class="ui-document-totals__value">{{ exchangeRate() }}</span>
            </div>
          }
        </div>
      } @else {
        <div class="ui-document-totals__fields">
          <ng-content select="[fields]" />
        </div>
      }
      @if (extraItems().length) {
        <div class="ui-document-totals__extra">
          @for (item of extraItems(); track item.label) {
            <div class="ui-document-totals__metric">
              <span class="ui-document-totals__label">{{ item.label }}</span>
              <span class="ui-document-totals__value">{{ item.value }}</span>
            </div>
          }
        </div>
      }
    </div>

    <div class="ui-document-totals__metric">
      <span class="ui-document-totals__label">Subtotal</span>
      <span class="ui-document-totals__value">{{ subtotal() }}</span>
    </div>
    <div class="ui-document-totals__metric">
      <span class="ui-document-totals__label">IVA</span>
      <span class="ui-document-totals__value">{{ iva() }}</span>
    </div>
    <div class="ui-document-totals__metric">
      <span class="ui-document-totals__label">Retención ISR</span>
      <span class="ui-document-totals__value">{{ retencionIsr() }}</span>
    </div>
    <div class="ui-document-totals__metric">
      <span class="ui-document-totals__label">Retención IVA</span>
      <span class="ui-document-totals__value">{{ retencionIva() }}</span>
    </div>
    <div class="ui-document-totals__metric ui-document-totals__metric--total">
      <span class="ui-document-totals__label">Importe</span>
      <span class="ui-document-totals__value">{{ importe() }}</span>
    </div>
  </div>
</ui-form-section>
